import script from "./TransactionsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionsList.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionsList.vue?vue&type=style&index=0&id=ea179806&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea179806"]])

export default __exports__